import { getProjectile } from '../helpers';
export const villainProjSet = {
    root: getProjectile('root'),
    octopi: getProjectile('octopi'),
    notchi: getProjectile('notchi'),
    perci: getProjectile('perci'),
    granslos: getProjectile('granslos'),
};
//# sourceMappingURL=BossFight.js.map